import Heading from '../components/heading'
import Accordion from '../components/Accordion'
import InfoTabs from '../components/NewTemplate/InfoTabs';
import BaseSlider from '../components/NewTemplate/BaseSlider';
import ClosestLots from '../components/NewTemplate/ClosestLots';
import AirportFaq from '../components/NewTemplate/AirportFaq';

Vue.component('page-landing', {

    components: {
        Accordion,  
        InfoTabs,
        BaseSlider,
        ClosestLots,
        AirportFaq
    },

    mixins: [Heading],

    data() {
        return {
            heading: null
        }
    },

    mounted() {
        this.heading = this.getQueryVariable('utm_term')
    },

    methods: {
        reviewReadMore(event) {
            let $readMore = $(event.target);
            let $first = $readMore.parent();
            let $second = $first.next();

            $first.hide();
            $second.show();
        },

        reviewReadLess(event) {
            let $readLess = $(event.target);
            let $second = $readLess.parent();
            let $first = $second.prev();

            $first.show();
            $second.hide();
        }
    }
});
